import React, { useState } from "react";
import styles from "./LoginForm.module.css";
import AccountService from "../../Services/accountService";
import { ToastProvider } from "../../LayoutComponents/ToastContext";
import i18n from "../../Services/i18n";
import { useLoader } from "../../LayoutComponents/GlobalLoader";
import { useAuth } from "../../LayoutComponents/UseAuth";
import PasswordInput from "../../LayoutComponents/PasswordInput";
import { usePrivileges } from "../../Context/PrivilegeContext";
import { useNavigate } from "react-router-dom";
import { useParameters } from "../../Context/ParameterContext";
const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [fail, setFail] = useState(false);

  const { saveToken } = useAuth();
  const { setPState } = usePrivileges();
  const { setParameterState } = useParameters();
  const navigate = useNavigate();

  const { showLoader, hideLoader } = useLoader();

  const handleLogin = async () => {
    showLoader();
    try {
      const response = await AccountService.Login(username, password, rememberMe, saveToken);
      if (response.status < 299) {
        setPState(response.data.packagePrivilege);
        setParameterState(response.data.accountParameters);
        navigate("/dashboard");
        hideLoader();
      } else if (response.status > 299 && response.status < 499) {
        hideLoader();
        setPassword("");
        setFail(true);
      }
    } catch (ex) {
      hideLoader();
      setPassword("");
      setFail(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginWrapper}>
        <div className={styles.equestrologLogo}>Equestrolog</div>
        <h2 className={styles.loginSlogan}>{i18n.t("LoginForm.Moto")} </h2>
        <form className={styles.loginForm} onSubmit={handleSubmit}>
          <div style={{ textAlign: "right" }}>
            <a href="/requestresetpassword">{i18n.t("LoginForm.ForgotPassword")}</a>
          </div>
          {fail && (
            <div style={{ marginBottom: "20px" }}>
              <span className={styles.loginErrorSpan}>{i18n.t("LoginForm.LoginFailed")}</span>
            </div>
          )}
          <label className={styles.loginLabel}>
            {i18n.t("LoginForm.FieldUsername")}
            <input
              type="text"
              className={styles.loginInput}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </label>
          <label className={styles.loginLabel}>
            {i18n.t("LoginForm.FieldPassword")}
            <PasswordInput
              className={styles.loginInput}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <label className={styles.loginCheckboxLabel}>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            {i18n.t("LoginForm.RememberMe")}
          </label>
          <div className={styles.loginFormFooter}>
            <button className={styles.loginButton} type="submit">
              {i18n.t("LoginForm.LoginButton")}
            </button>
          </div>
        </form>
        <div className={styles.signupSection}>
          <span>{i18n.t("LoginForm.NotMember")} </span>
          <a href="/signup" className={styles.signupLink}>
            {i18n.t("LoginForm.CreateAccount")}
          </a>
        </div>
      </div>
    </div>
  );
};

const LoginFormToasted = () => (
  <ToastProvider>
    <LoginForm />
  </ToastProvider>
);

export default LoginFormToasted;
